import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import useAuthentication from 'hooks/use-authentication';
import Pagination from 'components/pagination/pagination';
import Button from 'components/button/button';
import { ButtonStyle } from 'components/button/prop-types';
import QuestionAnswer from 'components/question-answer/question-answer';
import Loader from 'components/loader/loader';
import Modal from 'components/modal/modal';
import RichTextViewer from 'components/rich-text-viewer/rich-text-viewer';
import { getQuestions } from 'helpers/questions';
import GET_EXAM_ATTEMP from 'queries/exam-attempt-feedback.graphql';
import GET_QUESTIONS_BY_ATTEMP from 'queries/get-questions-by-exam-attempt.graphql';
export const FeedbackPage = () => {
    var _a;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [examAttemp, setExamAttemp] = useState(null);
    const [exam, setExam] = useState(null);
    const [questions, setQuestions] = useState([]);
    const { getUserIdFromToken, getExamIdFromToken, logout } = useAuthentication();
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [take, setTake] = useState(25);
    const [showDescription, setShowDescription] = useState();
    const { data: attempt, loading } = useQuery(GET_EXAM_ATTEMP, {
        variables: {
            userId: getUserIdFromToken(),
            examId: getExamIdFromToken(),
        },
        fetchPolicy: 'no-cache',
    });
    const { data: questionList, refetch: questionsRefetch } = useQuery(GET_QUESTIONS_BY_ATTEMP, {
        variables: {
            userId: getUserIdFromToken(),
            examId: getExamIdFromToken(),
            page: 1,
            take: 6,
        },
        fetchPolicy: 'no-cache',
    });
    const handleCloseSession = () => {
        logout(() => {
            window.location.href = '/welcome';
        });
    };
    const loadQuestions = () => {
        questionsRefetch({
            userId: getUserIdFromToken(),
            examId: getExamIdFromToken(),
            page: currentPage + 1,
            take
        });
    };
    useEffect(() => {
        var _a;
        if (exam && !exam.isFeedbackEnabled && !((_a = exam.examConfigurations) === null || _a === void 0 ? void 0 : _a.showGrade)) {
            navigate('/finish');
        }
    }, [exam]);
    useEffect(() => {
        attempt && (setExamAttemp(attempt.examAttempt),
            setExam(attempt.examAttempt.exam),
            setQuestions(getQuestions(attempt.examAttempt.exam.questions)));
    }, [attempt]);
    useEffect(() => {
        var _a;
        questionList && (setTotalRows(questionList.questionsByExam.total),
            setPageCount(Math.ceil(((_a = questionList.questionsByExam.total) !== null && _a !== void 0 ? _a : 1) / take)),
            setQuestions(getQuestions(questionList.questionsByExam.items)));
    }, [questionList]);
    useEffect(() => {
        loadQuestions();
    }, [take, currentPage]);
    return (_jsxs(_Fragment, { children: [showDescription && (_jsx(Modal, Object.assign({ title: showDescription.title, close: () => setShowDescription(undefined) }, { children: _jsx(RichTextViewer, { id: `question-${showDescription.id}-description`, content: showDescription.description || '' }, void 0) }), void 0)), loading || !attempt
                ? _jsx(Loader, {}, void 0)
                :
                    _jsxs(_Fragment, { children: [_jsx("h2", { children: exam === null || exam === void 0 ? void 0 : exam.title }, void 0), ((_a = exam === null || exam === void 0 ? void 0 : exam.examConfigurations) === null || _a === void 0 ? void 0 : _a.showGrade) && (_jsxs("h5", Object.assign({ className: "subtitle--main" }, { children: [t('FEEDBACK.SCORE'), " ", examAttemp ? examAttemp.score : '-', "/", exam === null || exam === void 0 ? void 0 : exam.score] }), void 0)), _jsx("p", { children: t('FEEDBACK.TEXT') }, void 0), (exam === null || exam === void 0 ? void 0 : exam.isFeedbackEnabled) && questions && questions.map(question => {
                                var _a, _b, _c;
                                return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "modal--inline modal--condensed" }, { children: [_jsxs("div", Object.assign({ className: "modal-header" }, { children: [_jsx("h6", Object.assign({ className: "modal-header__title" }, { children: question === null || question === void 0 ? void 0 : question.title }), void 0), _jsxs("div", Object.assign({ className: "label" }, { children: [question.questionAnswer ? question.questionAnswer.score : '-', "/", question.score] }), void 0)] }), void 0), _jsxs("div", Object.assign({ className: "modal-body" }, { children: [question && _jsx(QuestionAnswer, { question: question }, void 0), (((_a = question === null || question === void 0 ? void 0 : question.questionAnswer) === null || _a === void 0 ? void 0 : _a.feedback) && ((_b = question.questionAnswer) === null || _b === void 0 ? void 0 : _b.feedback.length) > 0) &&
                                                        _jsxs("div", Object.assign({ className: "container--feedback mt-3" }, { children: [_jsx("div", Object.assign({ className: "container--title" }, { children: _jsx("label", Object.assign({ className: "title--feedback" }, { children: t('FEEDBACK.FEEDBACK') }), void 0) }), void 0), _jsx(RichTextViewer, { id: `question-${question.id}-feedback`, content: ((_c = question === null || question === void 0 ? void 0 : question.questionAnswer) === null || _c === void 0 ? void 0 : _c.feedback) || '' }, void 0)] }), void 0)] }), void 0)] }), void 0) }, void 0));
                            }), (exam === null || exam === void 0 ? void 0 : exam.isFeedbackEnabled) && questions && totalRows > 25 && (_jsx(Pagination, { pagecount: pageCount, pageSelect: currentPage, updateSelectPage: setCurrentPage, totalrows: totalRows !== null && totalRows !== void 0 ? totalRows : 1, userperpage: take, updateTake: setTake }, void 0)), _jsx("div", Object.assign({ className: "button-group" }, { children: _jsx(Button, { className: [ButtonStyle.Secondary, ButtonStyle.Outline], title: t('GENERAL.LEAVE'), onClick: handleCloseSession }, void 0) }), void 0), _jsx("p", { children: _jsx("em", { children: t('FEEDBACK.HELP_MESSAGE') }, void 0) }, void 0)] }, void 0)] }, void 0));
};
export default FeedbackPage;
